<app-main-navigation [isloan]='loans' class="requests_active"></app-main-navigation>
<div style="margin-top:100px">
    <router-outlet></router-outlet>
</div>

